const files = require.context('./modules', false, /\.js$/);
const modules = {};

files.keys().forEach(key => {
    modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
});

import {find, saveQuestion} from '../../../api/module/question/question'
import {assessmentDetailsApi} from '../../../api/module/project/assessmentApi'
export default {
    namespaced: true,
    state: {
        itemId: null,
        paperKey: '',
        assessmentDetailsId: null,
        name: '',
        assessmentDetails: {}
    },
    mutations: {
        setItemId(state, id) {
            state.itemId = id
        },
        setPaperKey(state, paperKey) {
            state.paperKey = paperKey
        },
        setAssessmentDetails(state, data) {
            state.assessmentDetailsId = data.id
            state.name = data.name
            state.assessmentDetails = data
        }
    },
    actions: {
        async init({ state, rootState, commit,  dispatch,   getters, rootGetters }, id) {
            const assessmentDetails = await assessmentDetailsApi.getById(id)
            if (assessmentDetails) {
                console.log(assessmentDetails)
                commit('setAssessmentDetails', assessmentDetails)
                const paperKey = assessmentDetails.paperKey
                find({code: paperKey}).then((res) => {
                    if (res && res.data) {
                        const code = res.data.code;
                        commit('setPaperKey', code)
                        commit('setItemId', res.data.id)
                        const questionData = res.data.questionData
                        dispatch('indicator/init', questionData.indicatorTrees)
                        dispatch('paper/init', questionData.paperList)
                        dispatch('logic/init', questionData.logicList)
                        dispatch('allConfig/init', questionData.groupList)
                        dispatch('paperGroupScore/init', questionData.paperGroupScoreList)
                        console.log(res.data)
                    }else {
                        console.log("无数据")
                    }
                })
            }

            // let fromDataJSON = localStorage.getItem('questionData');
            // if (fromDataJSON){
            //     let fromData_ = JSON.parse(fromDataJSON);
            //     // 指标
            //     dispatch('indicator/init', fromData_.indicatorTrees)
            //     dispatch('paper/init', fromData_.paperList)
            //     dispatch('indicator/init', fromData_.indicatorTrees)
            //     dispatch('logic/init', fromData_.logicList)
            //     dispatch('allConfig/init', fromData_.groupList)
            // }else {
            //     localStorage.setItem('questionData', JSON.stringify({}));
            // }
        },
        changeNode({ state, rootState, commit,  dispatch,   getters, rootGetters }, payload) {
            dispatch('indicator/changeNode', payload)
            commit('paper/setCurrentCardIndex', null)
        },
        save({ state, rootState, commit,  dispatch,   getters, rootGetters }) {
            return saveQuestion({
                paperKey: state.paperKey,
                jsonData: JSON.stringify({
                    paperList: rootState.question.paper.paperList,
                    groupList: rootState.question.allConfig.groupList,
                    indicatorTrees: rootState.question.indicator.indicatorTrees,
                    logicList: rootState.question.logic.logicList,
                    paperGroupScoreList: rootState.question.paperGroupScore.paperGroupScoreList,
                })
            })
        }
    },
    modules
};
